export default [
	{
		logo: '/img/reviews/marker/ceo-photo.png',
		customer: {
			name: 'Sergey Pisotsky',
			post: '“MARKER GROUP” G.M.',
			contactLink: 'tel: +38 (067) 230-75-77',
		},
		// ceoComment: {
		//   autor: '',
		//   post: '',
		//   comment: ''
		// },
		task: `iOS and Android application to analyze main indicators of the mineral fertilizers market development.`,
		coopDuration: `Since 2019 up to this day.`,
		shortQuote: `It’s a rare example of an outsourcing company that really becomes a part of your team”`,
		content: `
      <p>Global Code is a rare example of an outsourcing company that really becomes a part of your team! Guys are interested in achieving goals of your particular business and in your market efficiency and uniqueness increase.</p>
      <p>I would like to highlight 3 points that distinguish the experience of working with the Global Code from previous outsourcing experiences.</p>
      <h3>Communication</h3>
      <p>Any work starts with it. Communication is especially important when it goes to the fields where you are insufficiently competent. And it becomes even more significant if your task has no analogues or similar examples.</p>
      <p>Global Code communication is initially professional, structured, in an understandable language and aimed at achieving the best possible results. I never repeat or remind anything. There was no need to "earn extra money" as a secretary for technical specialists you work with. And you don’t need an additional dictionary to translate what they said.</p>
      <h3>Attitude</h3>
      <p>They are so involved in your project that it feels like this team becomes a part of your own company. The work is in constant progress, in search of various options and recipes to achieve best results. It’s logical as GC offers a wide range of services, including promotion. Therefore, the better and more unique your product will be, the easier it will be working with it in the future.</p>
      <h3>Professionalism</h3>
      <p>Actually, the first two points are already a part of what I consider as professionalism. I also want to add that I got excellent results! Better than I expected. They always do everything on time, which is extremely important.</p>
      <p>As a result, "Global Code" focuses on long-term relations and expansion / deepening of cooperation. They are interested in achieving your business goals, in increasing your market efficiency and uniqueness. It’s a rare example of an outsourcing company that really becomes a part of your team!</p>
      `,
		images: [
			'/img/reviews/marker/1.png',
			'/img/reviews/marker/2.png',
			'/img/reviews/marker/3.png',
			'/img/reviews/marker/4.png',
			'/img/reviews/marker/5.png',
		],
		// site: '',
		appstore: 'https://apps.apple.com/ru/app/marker-ap/id1451579856',
		googleplay:
			'https://play.google.com/store/apps/details?id=info.markergroup.android&hl=ru&gl=US',
		// vk: '',
		// instagram: '',
		// facebook: '',
		// youtube: '',
		// telegram: '',
		// caseLink: '',
	},

	{
		logo: '/img/reviews/vfinterior/ceo-photo.png',
		customer: {
			name: 'Victoria Filimonova',
			post: 'Founder of “Victoria Filimonova interior designer”',
			contactLink: 'tel: +7 (920) 210-38-11',
		},
		// ceoComment: {
		//   autor: '',
		//   post: '',
		//   comment: ''
		// },
		task: `Create stylish website, understandable and accessible to anyone, at the same time it should be unique and outstanding.`,
		coopDuration: `Since 2019 up to this day.`,
		shortQuote: `Did all the work on the product from the beginning to the end on the same page`,
		content: `
      <p>The need to create a website was not sudden. I have been thinking about its creation for a long time and was negotiating with guys from Global Code for a while. We agreed on everything: terms, costs, organizational issues and got down to work.</p>
      <p>I didn't expect that all guys involved in my project would act so responsibly and conscientiously! The work was easy: answering questions, solving basic issues, checking the final product… Everything was at the highest level! We were "on the same page" from the beginning to the end. Website exceeded all my expectations, and turned out to be "bombastic"! Thanks to this, the level of my own company showed significant growth in regards to its professional status and number of clients. </p>
      <p>I will sincerely recommend Global Code and wish all the best in their future projects!</p>
    `,
		images: [
			'/img/reviews/vfinterior/1.png',
			'/img/reviews/vfinterior/2.png',
			'/img/reviews/vfinterior/3.png',
			'/img/reviews/vfinterior/4.png',
			'/img/reviews/vfinterior/5.png',
		],
		site: 'https://vfinterior.ru/',
		// appstore: '',
		// googleplay: '',
		// vk: '',
		// instagram: '',
		// facebook: '',
		// youtube: '',
		// telegram: '',
		// caseLink: '',
	},

	{
		logo: '/img/reviews/new-alaska/logo.png',
		customer: {
			name: 'Kirill Valerievich',
			post: '«New Alaska Volkhov Ltd» G.M.',
			contactLink: 'tel: +7 (921) 934-15-06',
		},
		// ceoComment: {
		//   autor: '',
		//   post: '',
		//   comment: ''
		// },
		task: `
      <ol>
        <li>Website redesign and mobile version development.</li>
        <li>Expert articles and product descriptions in Russian and English.</li>
        <li>Interactive map creation.</li>
      </ol>
    `,
		coopDuration: `Since 2016 up to this day. (website periodical support)`,
		shortQuote: `Creative, wide and technological approach`,
		content: `
      <p>
        <b>— What tasks brought you to Global Code?</b><br>
        — Website design, development, promotion and support.
      </p>
      <p>
        <b>— How long have you been cooperating with us?</b><br>
        — Since 2016.
      </p>
      <p>
        <b>— Why was our work helpful and valuable for your business?</b><br>
        — Now we have a respectable presentation of our company on the Internet.
      </p>
      <p>
        <b>— What most impressed you in our work?</b><br>
        — Clarity, transparency, ability to explain and convey the need for a particular decision or act.
      </p>
        <p>
        <b>— What strengths of the Global Code can you highlight?</b><br>
        — Creative, wide and technological approach, vast experience and knowledge of different issues in the web area.
      </p>
      <p>
        <b>— For what kind of tasks would you recommend us to your friends?</b><br>
        — To solve complex company problems in its presentation and promotion on the Internet.
      </p>
    `,
		images: [
			'/img/reviews/new-alaska/1.png',
			'/img/reviews/new-alaska/2.png',
			'/img/reviews/new-alaska/3.png',
			'/img/reviews/new-alaska/4.png',
		],
		site: 'http://www.newalaskavolkhov.ru/',
		// appstore: '',
		// googleplay: '',
		// vk: '',
		// instagram: '',
		// facebook: '',
		// youtube: '',
		// telegram: '',
		// caseLink: '',
	},
]
